export default "__VITE_ASSET__d49134b5__"